import { useParams } from "@reach/router";
import { useProject } from "../../hooks/useProject";
import { useTeam } from "../../hooks/useTeam";
import { Extras } from "./Quote";
import { BlankProjectNumbers } from "./blank/BlankProjectNumbers";

const BlankLogic = () => {
  const { projectId } = useParams();
  const { project, isLoading, error } = useProject(projectId);
  const { teamIsLoading, team } = useTeam();

  if (isLoading || teamIsLoading) return <div className="spinner" />;
  if (error) return <div>Error loading project</div>;

  return (
    <div className="my-4">
      <BlankProjectNumbers project={project} team={team} />
    </div>
  );
};

export default BlankLogic;
